import Choices from 'choices.js';

(function ($) {
	$(document).ready(function () {
		window.profet = {
			elements: {
				schoolGoalsFilter: false,
			},

			variables: {},

			init: function () {
				profet.setupExhibitSlider();
				profet.handleClicks();
				profet.setExhibitWrapperHeight();
				profet.handleSlickEvents();
				profet.handleResize();
				profet.handleHovers();
				profet.resetSchoolMaterialBoxesHeights();
				profet.lockSchoolMaterialWrapperHeight();
				profet.setupFrontPageBoxesSlider();
				profet.setupThumbnailsSlider();
				profet.setupAnimations();
				profet.handleScroll();
				profet.fadeInElementsOnScroll();
				profet.setupPDFViewer();
				profet.handleMatchHeight();
				profet.handleLeavePage();
				profet.handleSearchForm();
				profet.handleCloseCTABar();
				profet.setupSchoolGoalsFilter();
				profet.removeBRFromGravityForms();
				profet.trackSchoolMaterialInGoogleAnalytics();
				profet.setupToggleEasySwedishText();
				profet.handleSmoothScrollLinks();
				profet.handleElementFocus();
				profet.handleBVBAccordionToggle();
				profet.getCategoryFilterQueryParams();

				/* Set a timeout to (possibly) display the CTA bar after 10 seconds */
				window.setTimeout(() => {
					profet.handleShowCTABar();
				}, 10000);

				/* Trigger our fading background color animation and icon animation on the Blir Världen Bättre takeover after a few seconds */
				window.setTimeout(() => {
					var backgroundElement = $('.bvb-hero-section .bvb-background');
					if (backgroundElement) {
						backgroundElement.addClass('animate-background');
					}
				}, 5000);
				window.setTimeout(() => {
					var bvbElement = $('.bvb-hero-section');
					if (bvbElement) {
						bvbElement.addClass('show-icons');
					}
				}, 2000);
			},

			getCategoryFilterQueryParams() {
				var value = false;
				var url = new URL(document.location.href);
				var paramValue = url.searchParams.get('category_filter');
				if (paramValue) {
					value = paramValue;
					/* If there's a category filter value set, click that filter button to automatically set the filter. */
					var button = document.querySelector('[data-category-filter="' + value + '"]');
					button.click();
				}
				console.log(value);
				return value;
			},

			handleResize: function () {
				$(window).on('resize', function () {
					profet.lockSchoolMaterialWrapperHeight();
					profet.fadeInElementsOnScroll();
					profet.resizePDFViewer();
				});
			},

			handleLeavePage: function () {
				window.onbeforeunload = function (e) {
					var logo = $('.site-logo').find('img');
					var logoMobile = $('.globalamalen-header-mobile').find('img.logo');
					logo.addClass('logo-loading');
					logoMobile.addClass('logo-loading');
				};
			},

			handleMatchHeight: function () {
				$('.page-template-template-school-exercise').find('.printfriendly').find('a').matchHeight();
			},

			handleScroll: function () {
				$(window).on('scroll', function (event) {
					profet.fadeInElementsOnScroll();
				});

				/* Hide ajax search results when the mobile menu is scrolled for better user experience */
				/*
				$('.globalamalen-header-mobile')
					.find('.menu-wrapper')
					.on('scroll', function() {
						$('.searchwp-live-search-results').removeClass('searchwp-live-search-results-showing');
                    });
                */
			},

			handleHovers: function () {
				/*
                $('.gm-school-material-box').hover(function() {
                    $('.gm-school-material-box').each(function() {
                        $(this).css('height', $(this).attr('data-max-height') + 'px');
                    });
                    $(this).css('height', 'auto');
                }, function() {
                    $('.gm-school-material-box').each(function() {
                        $(this).css('height', 'auto');
                    });
                });
                */

				$('.school-material-feed-wrapper').mouseenter(function () {
					profet.lockSchoolMaterialWrapperHeight();
				});
			},

			handleSearchForm: function () {
				var mobileSearchForm = $('.mobile-search-wrapper').find('input');
				var desktopSearchForm = $('.search-desktop-wrapper').find('input');
				mobileSearchForm.on('keyup', function () {
					var value = $(this).val();
					if (value) {
						$('.clear-search-mobile').show();
					} else {
						$('.clear-search-mobile').hide();
					}
				});
				$('.clear-search-mobile').on('click', function (event) {
					event.preventDefault();
					mobileSearchForm.val('');
					$(this).hide();
				});
				desktopSearchForm.on('keyup', function () {
					var value = $(this).val();
					if (value) {
						$('.clear-search-desktop').show();

						var searchResults = $('.searchwp-live-search-results-showing');
						searchResults.appendTo('.search-results-wrapper');
					} else {
						$('.clear-search-desktop').hide();
					}
				});
				$('.clear-search-desktop').on('click', function (event) {
					event.preventDefault();
					desktopSearchForm.val('');
					$(this).hide();
				});
				$('.item-search-desktop')
					.find('a')
					.on('click', function (event) {
						event.preventDefault();
						$('.search-desktop-wrapper').toggleClass('toggled');
						window.setTimeout(function () {
							if ($('.search-desktop-wrapper').hasClass('toggled')) {
								$('.search-input-wrapper').find('input').focus();
							}
						}, 250);
					});
			},

			handleClicks: function () {
				$('.toggle-mobile-menu').on('click', function (event) {
					event.preventDefault();
					var menu = $('.globalamalen-header-mobile');
					if (menu.hasClass('toggled')) {
						menu.removeClass('toggled');
						$('body').removeClass('mobile-menu-toggled');
					} else {
						menu.addClass('toggled');
						window.setTimeout(function () {
							$('body').addClass('mobile-menu-toggled');
						}, 1000);
					}
				});

				$('[data-toggle-target]').on('click', function (event) {
					event.preventDefault();
					var target = $(this).attr('data-toggle-target');
					$(target).slideToggle();
				});

				$('.target-read-more').on('click', function (event) {
					event.preventDefault();
					$(this).siblings('.target-description').toggleClass('toggled');
					var newToggleText = $(this).find('span').attr('data-toggled-text');
					var oldToggleText = $(this).find('span').html();
					$(this).find('span').html(newToggleText);
					$(this).find('span').attr('data-toggled-text', oldToggleText);

					var fa = $(this).find('.fa');
					if (fa.hasClass('fa-plus')) {
						fa.removeClass('fa-plus');
						fa.addClass('fa-close');
					} else {
						fa.removeClass('fa-close');
						fa.addClass('fa-plus');
					}
				});

				$('.toggle-indications').on('click', function (event) {
					event.preventDefault();
					$(this).css('minWidth', $(this).outerWidth());
					$('.indications').slideToggle();
					var newToggleText = $(this).find('span').attr('data-toggled-text');
					var oldToggleText = $(this).find('span').html();
					$(this).find('span').html(newToggleText);
					$(this).find('span').attr('data-toggled-text', oldToggleText);

					var fa = $(this).find('.fa');
					if (fa.hasClass('fa-plus')) {
						fa.removeClass('fa-plus');
						fa.addClass('fa-close');
					} else {
						fa.removeClass('fa-close');
						fa.addClass('fa-plus');
					}
				});

				$('.show-all-tips').on('click', function (event) {
					event.preventDefault();
					$('.single-goal-additional-tips').slideToggle();
					$(this).css('minWidth', $(this).outerWidth());
					var newToggleText = $(this).find('span').attr('data-toggled-text');
					var oldToggleText = $(this).find('span').html();
					$(this).find('span').html(newToggleText);
					$(this).find('span').attr('data-toggled-text', oldToggleText);

					var fa = $(this).find('.fa');
					if (fa.hasClass('fa-plus')) {
						fa.removeClass('fa-plus');
						fa.addClass('fa-close');
					} else {
						fa.removeClass('fa-close');
						fa.addClass('fa-plus');
					}
				});

				$('.category-filter-button').on('click', function (event) {
					event.preventDefault();
					profet.handleCategoryFilterButtonClick($(this));
				});
				$('.duration-filter-button').on('click', function (event) {
					event.preventDefault();
					profet.handleCategoryFilterButtonClick($(this));
				});
				$('.exercise-type-filter-button').on('click', function (event) {
					event.preventDefault();
					profet.handleExerciseTypeFilterButtonClick($(this));
				});

				$('.toggle-long-quote').on('click', function (event) {
					event.preventDefault();

					//var longQuote = $('.slide-long-quote');
					var longQuote = $(this).parent();

					if (longQuote.hasClass('expanded')) {
						longQuote.attr('style', '');
						longQuote.css('opacity', '1');
						window.setTimeout(function () {
							longQuote.removeClass('expanded');
						}, 500);

						var toggleText = $(this).find('.toggle-text');
						toggleText.animate({ top: '40px' }, 500);
						window.setTimeout(function () {
							toggleText.html('Visa mer');
							toggleText.css('top', '-40px');
						}, 500);
						toggleText.animate({ top: '0px' }, 300);
					} else {
						var toggleText = $(this).find('.toggle-text');
						toggleText.animate({ top: '-40px' }, 500);
						window.setTimeout(function () {
							toggleText.html('Visa mindre');
							toggleText.css('top', '40px');
						}, 500);
						toggleText.animate({ top: '0px' }, 300);

						profet.setLongQuoteHeight(longQuote);
					}
				});

				$('a[href="#global-goals-detailed-list"]').on('click', function (event) {
					event.preventDefault();
					profet.smoothScrollTo('#global-goals-detailed-list');
				});
			},

			handleSmoothScrollLinks() {
				$('a[data-smooth-scroll-to]').on('click', function (event) {
					event.preventDefault();
					var element = $(this).attr('data-smooth-scroll-to');
					profet.smoothScrollTo(element);
				});
			},

			setupAnimations: function () {
				$('.animate-fade-in-on-load').addClass('animate-active');
			},

			setupSchoolGoalsFilter: function () {
				var goalsFilter = document.querySelector('#goal-filter-select');
				if (!goalsFilter) {
					return;
				}
				var options = {
					shouldSort: false,
					removeItemButton: true,
					searchEnabled: false,
					loadingText: 'Laddar...',
					noResultsText: 'Inga resultat',
					noChoicesText: 'Det finns inga val att välja på.',
					itemSelectText: 'Klicka för att välja',
				};
				profet.schoolGoalsFilter = new Choices(goalsFilter, options);
				goalsFilter.addEventListener('change', function (value) {
					window.setTimeout(function () {
						profet.showHideSchoolMaterial();
					}, 250);
				});
			},

			handleCategoryFilterButtonClick: function (element) {
				element.toggleClass('btn-active');
				profet.toggleShowAllFilterButtons(element);
				window.setTimeout(function () {
					profet.showHideSchoolMaterial();
				}, 250);
			},

			handleExerciseTypeFilterButtonClick: function (element) {
				if (element.hasClass('btn-active')) {
					$('.exercise-type-filter-button').removeClass('btn-active');
					$('.exercise-type-filter-all').addClass('btn-active');
				} else {
					$('.exercise-type-filter-button').removeClass('btn-active');
					element.addClass('btn-active');
				}
				window.setTimeout(function () {
					profet.showHideSchoolMaterial();
				}, 250);
			},

			toggleShowAllFilterButtons: function (element) {
				var durationFilterAll = $('.duration-filter-all');
				var categoryFilterAll = $('.category-filter-all');
				var exerciseTypeFilterAll = $('.exercise-type-filter-all');

				/* Make sure atleast one button is enabled */
				if (!$('.category-filter-button.btn-active').length) {
					categoryFilterAll.addClass('btn-active');
					return;
				}

				/* Make sure atleast one button is enabled */
				if (!$('.duration-filter-button.btn-active').length) {
					durationFilterAll.addClass('btn-active');
					return;
				}

				if (element.hasClass('duration-filter-all') && element.hasClass('btn-active')) {
					$('.duration-filter-button:not(.duration-filter-all)').removeClass('btn-active');
					return;
				}

				if (element.hasClass('category-filter-all') && element.hasClass('btn-active')) {
					$('.category-filter-button:not(.category-filter-all)').removeClass('btn-active');
					return;
				}

				if (durationFilterAll.hasClass('btn-active') && element.hasClass('duration-filter-button')) {
					durationFilterAll.removeClass('btn-active');
				}
				if (categoryFilterAll.hasClass('btn-active') && element.hasClass('category-filter-button')) {
					categoryFilterAll.removeClass('btn-active');
				}
			},

			showHideSchoolMaterial: function () {
				var activeFilters = $('.category-filter-button.btn-active');
				var schoolMaterialBoxes = $('.gm-school-material-box');
				schoolMaterialBoxes.hide();
				activeFilters.each(function () {
					var filterValue = $(this).data('category-filter');
					var classToShow = 'category-' + filterValue;

					if (filterValue == 'all') {
						classToShow = 'gm-school-material-box';
					}

					/* Only show the item if the duration of the exercise matches the duration selected in the filters */
					$('.' + classToShow).each(function () {
						var name = $(this).find('h4').html();
						if (
							$(this).hasClass(classToShow) &&
							profet.schoolMaterialIsWithinSelectedDuration($(this)) &&
							profet.schoolMaterialHasGoals($(this)) &&
							profet.schoolMaterialHasType($(this))
						) {
							$(this).show();
						}
					});
				});
				profet.unlockSchoolMaterialWrapperHeight();
				profet.lockSchoolMaterialWrapperHeight();
				window.setTimeout(function () {
					profet.resetSchoolMaterialBoxesHeights();
				}, 100);
				profet.toggleSchoolMaterialNotFound();
			},

			toggleSchoolMaterialNotFound: function () {
				var notFound = $('.school-material-not-found');
				var visibleMaterial = $('.gm-school-material-box').is(':visible');
				if (visibleMaterial) {
					notFound.hide();
				} else {
					notFound.show();
				}
			},

			schoolMaterialHasGoals: function (item) {
				var selectedValues = $('#goal-filter-select').val();
				var goalsForMaterial = item.attr('data-exercise-goals');
				if (goalsForMaterial) {
					goalsForMaterial = JSON.parse(goalsForMaterial);
				}
				/* If there are NO goals selected on the filter, return true */
				if (selectedValues == null || selectedValues.length == 0) {
					return true;
				}
				/* If the item has no goals and there are goals selected on the filter tools, return false */
				if (goalsForMaterial == undefined && selectedValues.length > 0) {
					return false;
				}
				var shouldBeDisplayed = false;
				var values = [];
				/* Get all values for the goal's material */
				for (var i in goalsForMaterial) {
					values.push(goalsForMaterial[i].value);
				}
				/* Loop over all goals that SHOULD exist on the material. If one doesn't exist, return false */
				for (var x in values) {
					var value = values[x];
					if (selectedValues.indexOf(value) > -1) {
						shouldBeDisplayed = true;
						break;
					}
				}
				return shouldBeDisplayed;
			},

			schoolMaterialHasType: function (item) {
				var selectedValue = $('.exercise-type-filter-button.btn-active').attr('data-exercise-type');
				var materialType = item.attr('data-exercise-type');
				materialType = JSON.parse(materialType);
				if (selectedValue == 'all') {
					return true;
				}
				/* Get all values for the goal's material */
				if (materialType.indexOf(selectedValue) > -1 || materialType.indexOf('all') > -1) {
					return true;
				}
				return false;
			},

			schoolMaterialIsWithinSelectedDuration: function (item) {
				var durations = profet.getFilterSchoolExerciseDurations();
				var shouldBeDisplayed = false;
				for (var i in durations) {
					var duration = durations[i];
					var materialDuration = item.attr('data-exercise-time');
					if (materialDuration >= duration.min && materialDuration <= duration.max) {
						shouldBeDisplayed = true;
					} else {
					}
				}
				return shouldBeDisplayed;
			},

			getFilterSchoolExerciseDurations: function () {
				var durations = [];
				$('.duration-filter-button.btn-active').each(function () {
					var time = {};
					time.min = $(this).data('duration-time-min-filter');
					time.max = $(this).data('duration-time-max-filter');
					durations.push(time);
				});
				return durations;
			},

			setExhibitWrapperHeight: function () {
				if (window.innerWidth < 900) {
					$('.single-exhibit-slide').css('maxHeight', window.innerHeight);
				}
			},

			setLongQuoteHeight: function (longQuote) {
				longQuote.addClass('expanded');
				var toggleButton = $('.toggle-long-quote');
				var topValue = window.innerHeight - longQuote.height() + toggleButton.height() * 2;

				/*
				if(topValue < 20) {
					topValue = 20;
				}*/

				longQuote.css('top', topValue);
			},

			setupThumbnailsSlider: function () {
				var slickConfig = {
					dots: false,
					slidesToShow: 1,
					arrows: true,
					touchThreshold: 10,
					speed: 240,
					infinite: true,
					prevArrow: '<button type="button" class="slick-arrow slick-prev" title="Föregående bild"></button>',
					nextArrow: '<button type="button" class="slick-arrow slick-next" title="Nästa bild"></button>',
				};
				$('.profet-thumbnails-and-image-slider-carousel').slick(slickConfig);

				$('a[data-slider-image]').on('click', function (event) {
					event.preventDefault();
					var imageId = $(this).attr('data-slider-image');
					$('.profet-thumbnails-and-image-slider-carousel').slick('slickGoTo', imageId);
				});
			},

			setupFrontPageBoxesSlider: function () {
				var slickConfig = {
					dots: false,
					slidesToShow: 1.15,
					arrows: false,
					touchThreshold: 10,
					speed: 240,
					infinite: false,
				};
				$('.front-page-box-slider').slick(slickConfig);
			},

			setupExhibitSlider: function () {
				$('.global-goals-exhibit-wrapper').slick({
					dots: false,
					prevArrow:
						'<button type="button" class="slick-prev" title="Föregående bild" aria-label="Föregående bild"><i class="fa fa-chevron-left"></i></button>',
					nextArrow:
						'<button type="button" class="slick-next" title="Nästa bild" aria-label="Nästa bild"><i class="fa fa-chevron-right"></i></button>',
					responsive: [
						{
							breakpoint: 900,
							settings: {
								arrows: false,
								dots: false,
							},
						},
					],
				});

				$('.slide-navigation-item-link').on('click', function () {
					var index = $(this).attr('data-slide-index');
					$('.global-goals-exhibit-wrapper').slick('slickGoTo', index);
				});

				$('.exhibit-next-slide').on('click', function () {
					$('.global-goals-exhibit-wrapper').slick('slickNext');
				});

				profet.doSlickSlideAnimations();
			},

			handleSlickEvents: function () {
				/* See all events at http://kenwheeler.github.io/slick/ */
				$('.global-goals-exhibit-wrapper').on('afterChange', function (slick) {
					profet.doSlickSlideAnimations();
					profet.setSlickNavigationItemsActiveClass();
				});

				$('.global-goals-exhibit-wrapper').on('init', function (slick, currentSlide) {
					profet.doSlickSlideAnimations();
				});
			},

			setSlickNavigationItemsActiveClass: function (currentIndex) {
				var currentIndex = $('.global-goals-exhibit-wrapper').slick('slickCurrentSlide');
				$('[data-slide-index]').parent().removeClass('slide-navigation-item-current');
				$('[data-slide-index="' + currentIndex + '"]')
					.parent()
					.addClass('slide-navigation-item-current');
			},

			doSlickSlideAnimations: function () {
				var currentSlideElement = $('.slick-current');

				/* Animate goal logo */
				var goalLogo = currentSlideElement.find('.slide-header').find('.goal-logo');
				goalLogo.animate(
					{
						left: '0px',
						opacity: '1',
					},
					500
				);

				window.setTimeout(function () {
					/* Animate quote */
					var slideQuote = currentSlideElement.find('.slide-quote');
					slideQuote.animate(
						{
							opacity: '1',
						},
						500
					);
				}, 1000);

				window.setTimeout(function () {
					/* Animate long quote */
					var slideLongQuote = currentSlideElement.find('.slide-long-quote');
					slideLongQuote.animate(
						{
							opacity: '1',
						},
						300
					);
				}, 1800);

				window.setTimeout(function () {
					var element = currentSlideElement.find('.company-logo-container');
					element.animate(
						{
							opacity: '1',
							top: '0px',
						},
						500
					);
				}, 500);

				window.setTimeout(function () {
					var element = currentSlideElement.find('.quote-text-wrapper');
					element.animate(
						{
							opacity: '1',
							top: '0px',
						},
						500
					);
				}, 1000);
			},

			unlockSchoolMaterialWrapperHeight: function () {
				var wrapper = $('.school-material-feed-wrapper');
				wrapper.css('height', 'auto');
			},

			lockSchoolMaterialWrapperHeight: function () {
				var wrapper = $('.school-material-feed-wrapper');
				var wrapperHeight = wrapper.outerHeight();
				wrapper.css('height', wrapperHeight);
			},

			resetSchoolMaterialBoxesHeights: function () {
				$('.gm-school-material-box').each(function () {
					$(this).attr('data-max-height', 'none');
				});
			},

			fadeInElementsOnScroll: function () {
				var elementsToFade = $('.animate-fade-in-on-scroll');
				var scrollPositionOnPage = $(window).scrollTop() + $(window).outerHeight();

				/* If a user focuses on an element that is a child of this element, fade everything in to ensure proper accessability. */
				elementsToFade.each(function () {
					var element = $(this);
					var links = $(this).find('a');
					links.on('focus', function () {
						element.addClass('animate-active');
					});
				});

				elementsToFade.each(function () {
					var elementTop = $(this).offset().top;
					var scrollBreakpoint = elementTop + $(window).outerHeight() / 5;
					if (scrollPositionOnPage > scrollBreakpoint) {
						$(this).addClass('animate-active');
					}
				});
			},

			setupPDFViewer: function () {
				profet.resizePDFViewer();
				$('[data-pdf-page]').on('click', function (event) {
					event.preventDefault();
					var page = $(this).attr('data-pdf-page');
					var object = $('.profet-pdf-viewer-main').find('iframe');
					var pdfBaseUrl = object.attr('data-base-url');
					var url = pdfBaseUrl + '#page=' + page;

					if (object.attr('src') == url) {
						object.attr('src', pdfBaseUrl);
						window.setTimeout(function () {
							object.attr('src', url);
						}, 500);
						return;
					}

					object.attr('src', url);

					profet.smoothScrollTo('.profet-pdf-viewer-main');
				});
			},

			resizePDFViewer: function () {
				var object = $('.profet-pdf-viewer-main:not(.school-exercise-pdf-viewer)').find('iframe');
				var objectHeight = object.width() * 1.31;
				object.css('height', objectHeight);
				/* Set the size of the school material pdf viewer */
				var schoolMaterialObjects = $('.school-exercise-pdf-viewer').find('iframe');
				schoolMaterialObjects.each(function () {
					var objectHeight = $(this).width() * 0.57;
					$(this).css('height', objectHeight);
				});
			},

			smoothScrollTo: function (element) {
				// Make sure this.hash has a value before overriding default behavior
				if (element !== '') {
					// Prevent default anchor click behavior

					// Using jQuery's animate() method to add smooth page scroll
					// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
					$('html, body').animate(
						{
							scrollTop: $(element).offset().top - 100,
						},
						800
					);
				} // End if
			},

			getCookie: function (cname) {
				var name = cname + '=';
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return '';
			},

			setCookie: function (cname, cvalue, exdays) {
				var d = new Date();
				d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
				var expires = 'expires=' + d.toUTCString();
				document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
			},

			handleShowCTABar: function () {
				var cookieValue = $('.cta-banner').find('.cta-banner-text').html();

				if (!cookieValue) {
					return;
				}

				/* Don't dispay this on the front page */
				if ($('body').hasClass('home')) {
					return;
				}
				/* Don't show it on the pages related to the "Blir världen bättre?" teachers guide */
				if (
					$('body').hasClass('page-template-template-bvb-teachers-guide-start') ||
					$('body').hasClass('page-template-template-bvb-teachers-guide-start-teachers') ||
					$('body').hasClass('page-template-template-bvb-teachers-guide-start-students') ||
					$('body').hasClass('single-bvb_tg_section')
				) {
					return;
				}

				var existingCookie = profet.getCookie('CTABarClosed');
				if (existingCookie) {
					existingCookie.replace(/ /g, '');
				}

				if (existingCookie == cookieValue.replace(/ /g, '')) {
					return;
				}

				/* Don't show the CTA banner if the cookie bar is already visible */
				var cookieBar = $('#cookiebar');
				if (cookieBar.hasClass('cookie-bar-show')) {
					return;
				}

				if (existingCookie != cookieValue) {
					$('.cta-banner').addClass('show-cta-banner');
				}
			},

			handleCloseCTABar: function () {
				var closeButton = $('.close-cta-banner');
				closeButton.on('click', function (event) {
					event.preventDefault();
					var cookieValue = $('.cta-banner').find('.cta-banner-text').html();
					profet.setCookie('CTABarClosed', cookieValue, 1);
					$('.cta-banner').fadeOut(500);
				});
			},

			/* A workaround to remove <br> tags that automatically get inserted to the Feedback form (using Gravity forms) which prevents us from styling the labels to make nicer checkboxes */
			removeBRFromGravityForms: function () {
				var elements = $('.gfield_checkbox').find('br');
				if (elements) {
					elements.each(function () {
						$(this).remove();
					});
				}
			},

			trackSchoolMaterialInGoogleAnalytics() {
				/* Track print friendly clicks in Google Analytics */
				$('span.print-link').on('click', function (event) {
					/* Check if the press was on the Print or Download button */
					var child = $(this).find('i.fa');
					var type = '';
					if (child.hasClass('fa-file-pdf-o')) {
						type = 'download';
					}
					if (child.hasClass('fa-print')) {
						type = 'print';
					}
					/* Get the h1 for this school material page and set it as the event label */
					var h1 = $('h1');
					var analyticsObjectToPush = {
						eventCategory: 'School material ' + type,
						eventAction: type,
						eventLabel: h1.html(),
						transport: 'beacon',
					};

					/* Track the event in Google Analytics 4 */
					gtag('event', 'School material interaction', {
						eventCategory: 'School material ' + type,
						eventAction: type,
						eventLabel: h1.html(),
					});

					/* Track form submission in Google Analytics */
					__gaTracker('send', 'event', analyticsObjectToPush);
				});

				/* Track Särskole school material link clicks in Google Analytics */
				$('.school-material-download-link').on('click', function (event) {
					/* Get the h1 for this school material page and set it as the event label */
					var linkTitle = $(this).find('.link-title').html();
					var analyticsObjectToPush = {
						eventCategory: 'School material',
						eventAction: 'Material download link click',
						eventLabel: linkTitle,
						transport: 'beacon',
					};

					/* Track the event in Google Analytics 4 */
					gtag('event', 'school_material_download', {
						event_label: linkTitle,
						event_category: 'School material',
					});

					/* Track form submission in Google Analytics */
					__gaTracker('send', 'event', analyticsObjectToPush);
				});
			},

			setupToggleEasySwedishText() {
				$('.toggle-easy-swedish-text').on('click', function (event) {
					event.preventDefault();
					$(event.currentTarget).toggleClass('active');
					$('.single-goal-easy-swedish-text').slideToggle(500);
					$('.single-goal-easy-swedish-text').toggleClass('active');
				});
			},

			handleElementFocus() {
				/*
                When the user clicks on an item on the page, add the 'no-focus-outline' class to the body. This prevents any links or buttons from having a focus outline. 
                If the user keys down with tab, remove this class since they are now navigating with the keyboard and we want to display outlines.
                */
				$('body').on('click', function (event) {
					$('body').addClass('no-focus-outline');
					/* Remove the class .in-focus from our header desktop elements to hide submenus that have been displayed when the user tabbed to them. */
					$('li.in-focus').removeClass('in-focus');
				});
				$('body').on('keydown', function (event) {
					$('body').removeClass('no-focus-outline');
				});
			},

			handleBVBAccordionToggle() {
				$('.bvb-toggle-accordion').on('click', function (event) {
					event.preventDefault();
					var parent = $(this).closest('.bvb-accordion-item-wrapper');
					var content = parent.find('.bvb-accordion-content');
					parent.toggleClass('toggled');
					content.slideToggle(500);
				});
			},
		};

		profet.init();
	});
})(jQuery);
